<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class AgencyReference extends Vue {
        render() {
            return null
        }
    }

    export default AgencyReference
</script>
